module.exports = __webpack_public_path__ + "img/arrow-right.45a57120.svg";